// HeadingH2
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import H3ScaleUp from './H3ScaleUp';

const colors = {
  a: "#412191", // purple
  b: "#27850A"  // green
};

const Wrapper = styled.div`
  padding: 50px 0;
  @media(min-width: 660px) {
    padding: 80px 0 90px 0;
  }
  h2 {
    margin: 0 auto;
    padding-left: 10px;
    padding-right: 10px;
    span {
      color: ${ props => props.secondary ? colors.a : colors.b };
    }
  }
  h3 {
    margin: 10px 0 0 0;
  }
`;
function HeaderH2({ className = "", ...props }) {

  const classNames = [ "common-heading-h-2 uk-flex uk-flex-column uk-flex-middle", className ].join(" ");

  return (
    <Wrapper className={ classNames }>
      <h2 { ...props }>
        { props.children}
      </h2>
      <H3ScaleUp className="uk-text-dash-decor">
        { props.tagline }
      </H3ScaleUp>
    </Wrapper>
  );
}

HeaderH2.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string
  ]),
  tagline: PropTypes.string,
  className: PropTypes.any
};

export default HeaderH2;


// WEBPACK FOOTER //
// ./src/features/common/HeadingH2.js